const env = {
  accessTokenKey: process.env.accessTokenKey as string,
  refreshTokenKey: process.env.refreshTokenKey as string,
  cookieDomain: process.env.cookieDomain as string,
  captchaKey: process.env.captchaKey as string,
  stripeKey: process.env.stripeKey as string,
  apiURL: process.env.API_URL as string,
  cabinetUrl: process.env.cabinetUrl as string,
  sitetUrl: process.env.siteUrl as string,
} as const;

Object.entries(env).forEach(([key, value]) => {
  if (!value) {
    throw new Error(`Missing env variable: ${key}`);
  }
});

export { env };
